<template>
  <content-dialog
    v-model="dialogOpen"
    :loading="loading"
    :title="`Message Content ${communication ? `(${via})` : ''}`"
    fullscreen-tablet
    min-height="70vh"
    width="800px"
    @hide="$emit('close')"
  >
    <template v-if="!!communication">
      <!-- Message -->
      <template v-if="communication.via === 'EMAIL'">
        <sticky-header static>
          Message
        </sticky-header>
        <div class="q-mx-md q-my-xs">
          <div
            class="html restricted"
            v-html="communication.content_long"
          />
        </div>
      </template>
      <template v-else-if="communication.via === 'SMS'">
        <q-list>
          <q-item-wrapper
            v-if="communication.content"
            :icon="icon"
            top
          >
            <q-item-label caption>
              SMS Message
            </q-item-label>
            <q-item-label>
              <nl2br :text="communication.content" tag="div" />
            </q-item-label>
          </q-item-wrapper>

          <q-separator
            v-if="communication.content"
            inset
            class="q-my-md"
          />

          <q-item-wrapper
            v-if="communication.content_long"
            icon="mdi-web"
            top
          >
            <q-item-label caption>
              Full Message (viewable via link)
            </q-item-label>
            <div class="q-py-md html" v-html="communication.content_long" />
          </q-item-wrapper>
        </q-list>
      </template>

      <!-- Attachments -->
      <div v-if="communication.files.length > 0">
        <sticky-header static>
          Attachments
        </sticky-header>

        <AttachmentList
          :files="communication.files"
          class="q-px-md q-pb-md"
        />
      </div>
    </template>
    <template v-else-if="!loading">
      <no-results title="Could not load message contents" />
    </template>
  </content-dialog>
</template>

<script>
import communicationMixin from 'components/partials/communications/communicationMixin'
import AttachmentList from 'components/partials/communications/AttachmentList.vue'

export default {
  components: {
    AttachmentList
  },
  mixins: [communicationMixin],
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  emits: ['close'],
  data () {
    return {
      viewingFileID: null,
      dialogOpen: false,
      loading: false,
      communication: null
    }
  },
  computed: {
    icon () {
      return this.getFieldValue(this.communication.via, 'icon')
    },
    via () {
      return this.getFieldValue(this.communication.via, 'label')
    }
  },
  watch: {
    'id' () {
      this.getMessage()
    }
  },
  methods: {
    async getMessage () {
      if (this.id === null) { return }

      this.communication = null
      this.dialogOpen = true
      this.loading = true
      const { status, payload } = await this.$get('v1/communications/message/contents', {
        id: parseInt(this.id)
      })
      this.loading = false
      if (status === 'success') {
        this.communication = payload
      }
    }
  },
  mounted () {
    this.getMessage()
  }
}
</script>
